export const adminType = {
  GET_USERS_LIST: "GET_USERS_LIST",
  GET_USERS_USAGE_LIST: "GET_USERS_USAGE_LIST",
  GET_RECHARGE_HISTORY: "GET_RECHARGE_HISTORY",
  GET_SUB_ACCOUNT_RECHARGE_HISTORY: "GET_SUB_ACCOUNT_RECHARGE_HISTORY",
  GET_SPENT_HISTORY: "GET_SPENT_HISTORY",
};
